import { PRECOMM_STATUS } from "../../constants";
import I10n from "../../features/i10n";
import Device from "../../models/Device";
import ProductInformationCache from "../../persistence/description-cache";

export const computeEligibleCategories = (baseCategories, baseSearch, showPrecommercializedProducts) => {
  const categories = baseCategories || [];
  const search = (baseSearch || '').toLowerCase();
  const eligibleCategories = [];

  for (let { references, label, translationKey, ...other } of categories) {
    let filteredRefs = references
      .filter((ref) => {
        // Propose precommercialized references only if the user enabled it.
        if (ref.commercializationStatus === PRECOMM_STATUS && !showPrecommercializedProducts) {
          return false;
        }
        return true;
      });

      if (search.length) {
        const keywords = search.split(' ').filter(k => !!(k || '').length);
        filteredRefs = filteredRefs.filter(ref => {
          const device = new Device(ref);

          const deviceFields = [
            device.id,
            I10n.getOrDefault(`modules.${device.id}.description`, device.description, 'data'),
            ProductInformationCache.getDescription(device.id),
            I10n.getOrDefault(`category.${translationKey}.name`, label, 'data')
          ].map(f => (f || '').toLowerCase());

          return !!deviceFields.filter(field => {
            return keywords.filter(keyword => field.includes(keyword)).length === keywords.length;
          }).length;
        });

      }

      if (filteredRefs.length) {
        eligibleCategories.push({
          ...other,
          label,
          translationKey,
          'references': filteredRefs,
        });
      }
  }

  return eligibleCategories;
}

export const shouldShowPrecommToggle = (categories) => {
  return (categories || [])
    .some(category => category.hasPrecommercializedReferences);
}
